import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';

export const setChangePasswordWidgetCurrentPassword = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_CURRENT_PASSWORD`,
  (currentPassword: string) => ({ currentPassword })
);

export const setChangePasswordWidgetNewPassword = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_NEW_PASSWORD`,
  (newPassword: string) => ({ newPassword })
);

export const setChangePasswordWidgetNewPasswordRepeat = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_NEW_PASSWORD_REPEAT`,
  (newPasswordRepeat: string) => ({ newPasswordRepeat })
);

export const {
  submit: saveChangePassword,
  success: saveChangePasswordSuccess,
  failure: saveChangePasswordFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_CHANGE_PASSWORD');
